import { ref } from 'vue';

export type CampaignsCacheState = {
  data: Bemob.Campaign[];
  isUploaded: boolean;
  isAllInCache: boolean;
  uploadedForWorkspace: string | null;
};

export const createCampaignsCacheModule = () => {
  const campaignsCache = ref<CampaignsCacheState>({
    data: [],
    isUploaded: false,
    isAllInCache: false,
    uploadedForWorkspace: null,
  });

  const populateCampaignsCache = (payload: Bemob.Campaign[]) => {
    campaignsCache.value.data = payload;
    campaignsCache.value.isAllInCache = (payload?.length ?? 0) < 199;
    campaignsCache.value.isUploaded = true;
    campaignsCache.value.uploadedForWorkspace = null;
  };

  const updateCampaignsCache = (payload: { workspaceId: string; data: Bemob.Campaign[] }) => {
    campaignsCache.value.data = payload.data;
    campaignsCache.value.uploadedForWorkspace = payload.workspaceId;
  };

  const markCampaignsCacheStale = () => {
    campaignsCache.value.isUploaded = false;
  };

  const resetCampaignsCache = () => {
    campaignsCache.value = {
      data: [],
      isUploaded: false,
      isAllInCache: false,
      uploadedForWorkspace: null,
    };
  };

  const reset = () => {
    resetCampaignsCache();
  };

  return {
    state: {
      campaignsCache,
      populateCampaignsCache,
      updateCampaignsCache,
      markCampaignsCacheStale,
      resetCampaignsCache,
    },
    reset,
  };
};
